import {FC} from 'react'
import {useParams} from 'react-router-dom'
import {EntityActivityLogs} from '@/features/entity-activity-logs/components/entity-activity-logs/EntityActivityLogs'

export const UserActivityLogs: FC = () => {
    const {id} = useParams<{id: string}>()
    return <EntityActivityLogs entityType="users" entityId={id} />
}
